import close from "../../assets/icons/close.svg";
import "../../assets/css/Modal.css";
import { Postdata } from "../../API/GlobalApi";
import { useState } from "react";
import Notifier from "../../Utils/notify";
import useAutoFocus from "../../Utils/autoFocus";

export const DiscountPreviewModal = ({ isOpen, onClose, previewData, onContinue, selectedSessionName }) => {
    const [pin, setPin] = useState("");
    const ref = useAutoFocus(isOpen)
    if (!isOpen) return null;

    const { students, feeHeadNames, discountAmount, feeRow, occurrence, occurrenceSemesters = [] } = previewData;

    const totalDiscount = students.length * Number(discountAmount || 0);

    const handleVerifyPinAndContinue = async () => {
        if (pin.length !== 4) return;
        try {
            const res = await Postdata("core/verify-user-pin/", { pin });
            if (!res?.error) {
                if (typeof onContinue === "function") onContinue();
                setPin("");
            } else {
                Notifier.error(res?.data?.message || "Invalid PIN");
            }
        } catch (err) {
            Notifier.error("Something went wrong while verifying PIN");
        }
    };
    console.log("previewData", previewData)
    // 🔹 Print function
    const handlePrint = () => {
        if (typeof onClose === "function") onClose();

        const tableHtml = `
                    <table border="1" cellspacing="0" cellpadding="6" style="width:100%; border-collapse: collapse; font-size:14px;">
                        <thead>
                            <tr>
                                <th>Student Name</th>
                                <th>Registration No</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${students.map(stu => `
                                <tr>
                                    <td>${stu.name}</td>
                                    <td>${stu.rollNumber}</td>
                                    <td>₹${Number(discountAmount || 0).toFixed(2)}</td>
                                </tr>
                            `).join("")}
                        </tbody>
                    </table>`;

        const newWindow = window.open("width=800,height=1100");
        newWindow.document.write(`
                <html>
                <head>
                    <title>Discount Preview</title>
                    <style>
                        body { font-family: "Courier New", Courier, monospace; padding: 40px 0; color: #222F3E; background: #fff; }
                        .print-container { width: 600px; margin: 0 auto; }
                        h2{ margin: 4px 0; text-align: left; }
                        h3{ text-align: left; }
                        h2, p { margin: 4px 0; text-align: left !important; }
                        hr { border: 0; border-top: 1px dashed #222F3E; margin: 10px 0; }
                        table { width: 100%; border-collapse: collapse; font-size: 14px; margin-top: 10px; }
                        table th, table td { border: 1px solid #222F3E; padding: 6px; }
                        table th { text-align: left; }
                        .center { text-align: left; }
                    </style>
                </head>
                <body>
                    <div class="print-container">
                        <div class="center">
                            <h2>BITE College</h2>
                            <p>Banaras Institute of Teachers Education</p>
                            <hr />
                            <h3>Discount Preview</h3>
                            <hr />
                        </div>
                         <p><strong>Admission Academic Year:</strong> ${selectedSessionName}</p>
                        <p><strong>Total Students:</strong> ${students.length}</p>
                        <p><strong>Fee Head:</strong> ${feeHeadNames.join(", ")}</p>
                        <p><strong>Total Discount:</strong> ₹${totalDiscount.toFixed(2)}</p>
                        ${occurrence === "each_time"
                ? `<p><strong>Applicable Semesters:</strong> ${occurrenceSemesters
                    .map(s => s.label)
                    .join(", ")}</p>`
                : ""
            }
                        <hr />
                        ${tableHtml}
                                <div style="margin-top:80px; display:flex; justify-content:flex-end; width:100%;">
                              
                                <div>Director</div>
                             </div>
                        <hr />
                        <div class="center">
                            <p>Generated on: ${new Date().toLocaleString()}</p>
                        </div>
                    </div>
                    </body>
                </html>
                    `);
        newWindow.document.close();
        newWindow.focus();
        newWindow.print();
        newWindow.close();
    };

    return (
        <div className="modal-overlay">
            <div
                className="modal-content"
                style={{
                    width: "60%",
                    padding: "20px",
                    maxHeight: "80vh",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                {/* Header */}
                <div className="modal-header-content" style={{ display: "flex", justifyContent: "space-between" }}>
                    <h2 className="text-primary">Discount Preview</h2>
                    <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                        <button className="add-btn" onClick={handlePrint}>Print Preview</button>
                        <button className="close-btn" onClick={onClose}>
                            <img src={close} alt="close" />
                        </button>
                    </div>
                </div>
                <div className="row">
                    {/* Summary */}
                    {/* {selectedSessionName && (
                        <p>
                            <strong>Admission Academic Year:</strong> {selectedSessionName}
                        </p>
                    )} */}
                    <div className="col-md-6 d-flex flex-column gap-2">
                        <p><strong>Total Students:</strong> {students.length}</p>
                        <p><strong>Discount Name:</strong> {feeRow?.discountName}</p></div>
                    <div className="col-md-6 d-flex flex-column gap-2"> <p><strong>Discount Amount:</strong> ₹{totalDiscount}</p>
                        <p><strong>Fee Head:</strong> {feeHeadNames.join(", ")}</p></div>
                </div>
                <div className="row mt-2  d-flex flex-column gap-2">
                    <div className="col-md-6 d-flex flex-column gap-2">
                        <p>
                            <strong>Occurrence Type:</strong>{" "}
                            {occurrence === "each_time" ? "Each Time" : "One Time"}
                        </p>
                    </div>

                    {occurrence === "each_time" && (
                        <div className="col-md-12 d-flex flex-column gap-2">
                            <p>
                                <strong>Applicable Semesters:</strong>{" "}
                                {occurrenceSemesters.map(sem => sem.label).join(", ")}
                            </p>
                        </div>
                    )}
                </div>

                {/* Students Table */}
                <div style={{ flex: 1, overflowY: "auto", maxHeight: "50vh" }}>
                    <table className="table table-bordered mt-3">
                        <thead style={{ position: "sticky", top: 0, background: "#fff", zIndex: 2 }}>
                            <tr>
                                <th>Student Name</th>
                                <th>Registration No</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {students.map((stu, idx) => (
                                <tr key={idx}>
                                    <td>{stu.name}</td>
                                    <td>{stu.rollNumber}</td>
                                    <td>₹{discountAmount}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Footer */}
                <div style={{ display: "flex", justifyContent: "end", marginTop: "20px" }}>
                    <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                        <input
                            type="password"
                            className="form-control"
                            maxLength={4}
                            placeholder="Enter 4-digit PIN"
                            ref={ref}
                            value={pin}
                            onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))}
                            style={{
                                width: "150px",
                                padding: "8px 10px",
                                textAlign: "center",
                                fontSize: "13px",
                                border: "1px solid #ccc",
                                borderRadius: "6px",
                                outline: "none",
                                boxSizing: "border-box",
                            }}
                        />
                        <button
                            className="add-btn"
                            onClick={handleVerifyPinAndContinue}
                            disabled={pin.length !== 4}
                            style={{
                                cursor: pin.length !== 4 ? "not-allowed" : "pointer",
                                backgroundColor: pin.length !== 4 ? "#d3d3d3" : "#7F56DA",
                            }}
                        >
                            Continue
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
